import { useLayoutEffect } from 'react';

import { useIntercom } from '@zenbusiness/application-commons-intercom';
import { Outlet } from 'react-router-dom';

import Box from '@mui/material/Box';

const MarketingToolsLayout = () => {
  const { update: updateIntercom } = useIntercom();

  useLayoutEffect(() => {
    // show Intercom again
    if (window.Intercom) {
      // NOTE: There is an odd problem with react and the intercom button,
      // whenever a child page of this layout uses a "map" function to render
      // multiple child components, the intercom button hides automatically.
      // We believe there is a race condition so the button is being hidden from another place
      setTimeout(() => {
        updateIntercom({
          hide_default_launcher: false
        });
      }, 3000 /* 3000ms best value to avoid race condition */);
    }

    return () => {
      // hide Intercom bubble
      if (window.Intercom) {
        updateIntercom({
          hide_default_launcher: true
        });
      }
    };
  }, [updateIntercom]);

  return (
    <Box
      sx={{
        maxWidth: 1440,
        margin: {
          xl: 'auto'
        }
      }}
    >
      <Outlet />
    </Box>
  );
};

export default MarketingToolsLayout;
